import Ship from "./containers/Ship";
export default Ship;